import { all, fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { fetchDetail, fetchTable, sendData } from '../helpers/sagaHelpers';

function* watchFetchOfficeKindsTable() {
  yield takeLatest('officeKinds/fetchTable', fetchTable);
}

function* watchFetchOfficeKindDetail() {
  yield takeLatest('officeKinds/fetchDetail', fetchDetail);
}

function* watchSendOfficeKindDetail() {
  yield takeEvery('officeKinds/submitDetail', sendData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchOfficeKindsTable),
    fork(watchFetchOfficeKindDetail),
    fork(watchSendOfficeKindDetail)
  ]);
}
